import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h2 className="text-2xl font-bold text-slate-100 font-serif mb-6" data-id="element-46">
      Política de Privacidad
    </h2>
    <div className="space-y-4 text-slate-300 font-sans leading-relaxed text-sm" data-id="element-47">
      <p data-id="element-48">
        <strong className="text-slate-100" data-id="element-49">Última actualización:</strong> Abril
        2026
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-50">
        1. Información que recopilamos
      </h3>
      <p data-id="element-51">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos datos de tarjetas de
        crédito; estos son procesados de forma segura por nuestro proveedor de
        pagos.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-52">
        2. Uso de la información
      </h3>
      <p data-id="element-53">Tu información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-54">
        <li data-id="element-55">Enviar el producto digital adquirido a tu correo electrónico.</li>
        <li data-id="element-56">Comunicarnos con vos en caso de problemas con tu pedido.</li>
        <li data-id="element-57">
          Enviar actualizaciones del producto, solo si diste tu consentimiento.
        </li>
      </ul>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-58">
        3. Compartir información
      </h3>
      <p data-id="element-59">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros, excepto cuando sea necesario para procesar tu compra
        (procesadores de pago) o cuando la ley lo requiera.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-60">4. Cookies</h3>
      <p data-id="element-61">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para mejorar tu experiencia. Podés desactivar las cookies
        desde la configuración de tu navegador.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-62">
        5. Seguridad
      </h3>
      <p data-id="element-63">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-64">
        6. Tus derechos
      </h3>
      <p data-id="element-65">
        Tenés derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, escribinos a nuestro
        correo de soporte.
      </p>
    </div>
  </>;
const termsContent = <>
    <h2 className="text-2xl font-bold text-slate-100 font-serif mb-6" data-id="element-66">
      Términos y Condiciones
    </h2>
    <div className="space-y-4 text-slate-300 font-sans leading-relaxed text-sm" data-id="element-67">
      <p data-id="element-68">
        <strong className="text-slate-100" data-id="element-69">Última actualización:</strong> Abril
        2026
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-70">
        1. Producto digital
      </h3>
      <p data-id="element-71">
        Al realizar tu compra, adquirís una licencia personal e intransferible
        para acceder al contenido digital "Kit Gato Zen". El producto se entrega
        en formato digital (PDF/eBook) a la dirección de correo electrónico
        proporcionada al momento de la compra.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-72">2. Entrega</h3>
      <p data-id="element-73">
        El producto se envía de forma automática e inmediata al correo
        electrónico registrado. Si no recibís el producto dentro de los 30
        minutos posteriores a la compra, revisá tu carpeta de spam o contactanos
        para asistencia.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-74">
        3. Propiedad intelectual
      </h3>
      <p data-id="element-75">
        Todo el contenido del Kit Gato Zen, incluyendo textos, imágenes, métodos
        y técnicas descritas, está protegido por derechos de autor. Queda
        prohibida su reproducción, distribución o reventa total o parcial sin
        autorización expresa.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-76">
        4. Política de reembolso
      </h3>
      <p data-id="element-77">
        Debido a la naturaleza digital del producto, no se aceptan devoluciones
        una vez entregado el contenido. Si experimentás problemas técnicos para
        acceder al material, contactanos y te ayudaremos a resolverlo.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-78">
        5. Limitación de responsabilidad
      </h3>
      <p data-id="element-79">
        El contenido del Kit Gato Zen es de carácter informativo y educativo.
        Los resultados pueden variar según cada caso particular. No nos hacemos
        responsables por el uso inadecuado del material ni reemplazamos la
        consulta con un profesional veterinario cuando sea necesario.
      </p>

      <h3 className="text-lg font-semibold text-slate-100 pt-2" data-id="element-80">
        6. Modificaciones
      </h3>
      <p data-id="element-81">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación en este
        sitio.
      </p>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 border-t border-white/5 bg-navy-dark" data-id="element-82">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 flex flex-col items-center gap-4" data-id="element-83">
          <div className="flex items-center gap-6" data-id="element-84">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-slate-500 font-sans hover:text-gold transition-colors" data-id="element-85">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-86">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-slate-500 font-sans hover:text-gold transition-colors" data-id="element-87">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm text-slate-500 font-sans" data-id="element-88">
            &copy; {new Date().getFullYear()} Gato Zen. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-89">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-90">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-navy-light border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-91">
              {/* Header */}
              <div className="flex items-center justify-end p-4 border-b border-white/5" data-id="element-92">
                <button onClick={() => setActiveModal(null)} className="p-2 rounded-lg hover:bg-white/5 transition-colors text-slate-400 hover:text-slate-100" data-id="element-93">
                  <XIcon className="h-5 w-5" data-id="element-94" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 sm:p-8 overflow-y-auto max-h-[calc(80vh-64px)]" data-id="element-95">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}